export enum PrecatorioExpeditionType {
  PRE_PRECATORIO = "PRE_PRECATORIO",
  PRECATORIO_EXPEDIDO = "PRECATORIO_EXPEDIDO",
  LOA_REGISTRATION = "LOA_REGISTRATION"
}

export const PrecatorioExpeditionTypeLabel = new Map<PrecatorioExpeditionType, string>([
	[
		PrecatorioExpeditionType.PRECATORIO_EXPEDIDO,		'Precatório'
  ],
  [
		PrecatorioExpeditionType.PRE_PRECATORIO,		'Pré Precatório'
  ],
  [
		PrecatorioExpeditionType.LOA_REGISTRATION,		'Inscrito na LOA'
  ]
]);


// WEBPACK FOOTER //
// ./src/services/Enum/PrecatorioExpeditionTypeEnum.ts